import { retrieveItem } from "@src/helpers/functions";

export const useCheckPageAccess = (key: string) => {
  let hasAccess: boolean | null = null;
  const pageAccesses =
    retrieveItem("page_accesses") ?? retrieveItem("pageAccesses") ?? [];

  try {
    let pageAccess = pageAccesses.find((x: string) => x === key);

    if (pageAccess) {
      hasAccess = true;
    } else {
      hasAccess = false;
    }
  } catch (e) {
    hasAccess = false;
  }
  return hasAccess;
};